import React, { Component } from 'react';
import GoogleMapReact,{InfoWindow,Marker} from 'google-map-react';
import {  firebaseDB, firebasePosts } from '../../../firebase';
import { firebaseLooper } from '../../ui/misc';
//import { InfoModal } from 'hermes-react';
const AnyReactComponent = ({ text }) => (
  <div style={{
    color: 'white', 
    background: 'grey',
    padding: '15px 10px',
    display: 'inline-flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100%',
    transform: 'translate(-50%, -50%)',
  }} >
    {text}
  </div>
);

class SimpleMap extends Component {
      
      static defaultProps = {
        center: {
          lat: 34.070400,
          lng: -118.446918
        },
        zoom: 16
      };
      
      state={
        isOpen:'',
        allPost:[]
      }
      
      componentDidMount(){
          
          firebasePosts.once('value').then(snapshot=>{
                const posts = firebaseLooper(snapshot);
                console.log(posts);
                this.setState({
                  isOpen:'',
                  allPost:posts
                })
            })
      }
      // click=  () =>{
      //   alert("Hi!");
      // }
    //  click=(title)=>{
    //    <InfoWindow >
    //      {title}
    //    </InfoWindow>
    //  }
  render() {
    
    return (
      // Important! Always set the container height explicitly
      <div style={{ height: '100vh', width: '100%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyCzypKLsT9PMSPgIqqKLtuPDkQdBRb3QNI" }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
            
           <AnyReactComponent
             lat={this.props.center.lat}
             lng={this.props.center.lng}
             text="You are here!"
          /> 
          
          {this.state.allPost.map((post,i)=>(
              <AnyReactComponent
              key={i}
              lat={post.latitude}
              lng={post.longitude}
              text={post.job_title+'\n'+post.salary+'$'}
              /> 
          ))} 
        </GoogleMapReact>
      </div>
    );
  }
}
export default SimpleMap;


// WEBPACK FOOTER //
// ./src/Components/home/googlemap/index.js